import * as tslib_1 from "tslib";
import React from 'react';
import FormText from './FormText';
import { InputWrapper } from 'sinoui-components/TextInput';
import styled from 'sinoui-components/styles';
var StyledInputWrapper = styled(InputWrapper)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  padding-top: 4px;\n  min-height: 36px;\n  &:hover:before {\n    background-color: ", ";\n    height: 1px;\n  }\n"], ["\n  padding-top: 4px;\n  min-height: 36px;\n  &:hover:before {\n    background-color: ", ";\n    height: 1px;\n  }\n"])), function (props) { return props.theme.palette.input.bottomLine; });
export default function ReadonlyText(props) {
    return (React.createElement(StyledInputWrapper, null,
        React.createElement(FormText, tslib_1.__assign({}, props))));
}
var templateObject_1;
//# sourceMappingURL=ReadonlyText.js.map